import React, { useState, useEffect } from 'react';
import qs from 'qs';
import { FormControl, Button, Typography, InputBase, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

export default function RequestPasswordReset() {
  const queryString = (document.location.search || '').slice(1);
  const params = qs.parse(queryString);
  const [email, setEmail] = useState(params.email || '');
  const { i18n, t } = useTranslation();

  useEffect(() => {
    const lang = document.documentElement.lang;
    i18n.changeLanguage(lang);
    moment.locale(lang);
  }, [i18n]);

  function handleRequestPasswordClick() {
    document.getElementsByTagName('form')[0].submit();
  }

  function handleKeyPress(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key === 'Enter') {
      handleRequestPasswordClick();
    }
  }

  function shouldRender() {
    const elements = document.querySelectorAll(
      "[data-mount='ape_password_reset_request']"
    );

    return elements.length > 0;
  }

  if (!shouldRender()) {
    return <div />;
  }

  return (
    <Box sx={{ maxWidth: '328px', margin: '0 auto' }}>
      <Typography variant="h1">{t('Request Password Reset')}</Typography>
      <Typography variant="body1" sx={{ m: '24px 0' }}>
        {t(
          'We’ll send you an email with instructions on how to reset your password.'
        )}
      </Typography>
      <FormControl variant="standard" fullWidth>
        <InputBase
          onKeyPress={handleKeyPress}
          id="email"
          name="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          placeholder={t('Your email address')}
        />
        <Button
          color="primary"
          variant="contained"
          sx={{ mt: 5 }}
          type="submit"
          onClick={handleRequestPasswordClick}
        >
          {t('Send password reset link')}
        </Button>
      </FormControl>
    </Box>
  );
}
